<!-- eslint-disable max-len -->
<i18n lang="yaml">
  en:
    title: <span class="color-green">Welcome</span><br /> to the energy savings calculator
    paragraph: Changing to Ween will have a positive impact on your wallet. Ka-ching!<br />Oh and you will also be contributing to helping the planet. Still nice.
    button: Let's go
  fr:
    title: <span class="color-green">Bienvenue</span><br /> sur le simulateur Ween
    paragraph: Utiliser Ween, c'est agir pour la planète et économiser sur votre
      facture. Estimez dès maintenant vos économies et la réduction de votre
      empreinte carbone en moins d'une minute chrono.
    button: C'est parti
</i18n>
<!-- eslint-enable max-len -->

<template>
  <section class="economy || space-pb-7 space-pb-0--s">
    <div class="economy__bg || color-white-smoke">
      <svg-icon-circle />
    </div>
    <div class="page-center">
      <div class="grid">
        <div class="grid__row grid__row--center">
          <div class="grid__col-12--xxs grid__col-6--s">
            <img src="/img/product-specification.png" alt="Image thermostat" />
          </div>

          <div class="grid__col-12--xxs grid__col-6--s">
            <div class="type-align-center type-align-left--s">
              <!-- eslint-disable vue/no-v-html -->
              <h1
                class="type-title-secondary type-title-primary--s type-weight-700 type-align-center type-align-left--s space-mb-2"
                v-html="$t('title')"
              />
              <!-- eslint-enable vue/no-v-html -->
              <p class="type-body type-subtitle--s || space-mb-5" v-html="$t('paragraph')" />
              <nuxt-link
                class="btn btn--primary"
                :to="localePath({
                  name: 'economy-step',
                  params: {
                    step: '1'
                  }
                })"
              >{{ $t('button') }}</nuxt-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SvgIconCircle from '~/assets/svg/icon-circle.svg';

export default {
  layout: 'configurator',
  components: {
    SvgIconCircle,
  },
  nuxtI18n: {
    paths: {
      en: '/economy',
      fr: '/economie',
    },
  },
  created() {
    this.$store.dispatch('economy/resetFormState');
  },
};
</script>

<style lang="scss">
.economy {
  @media #{md('m')} and (min-height: 700px) {
    display: flex;
    align-items: center;
  }
}

.economy__bg {
  z-index: -1;
  position: fixed;
  top: 5%;
  left: 50%;
  transform: translate(-50%, -50%);

  svg {
    width: 150vw;
    height: 150vw;
  }

  @media #{md('s')} {
    top: 50%;
    left: -10%;

    svg {
      width: 100vw;
      height: 100vw;
    }
  }
}
</style>
